// extracted by mini-css-extract-plugin
export default {"wrapper":"MicrogridStrategy_wrapper__Q8GNU"};